import React from "react";
import * as Styled from "./NewVersionAlert.styled";
import { TextInput } from "../../../libs";
import { BaseButton } from "../../../libs";
import { useFormik } from "formik";
import * as Yup from "yup";

export const NewVersionAlert: React.FC<{
    onClose: () => void;
    handleSaveVersion: (name: string) => void;
    initialVersionName?: string;
    isEdit?: boolean;
}> = ({ onClose, handleSaveVersion, initialVersionName = "", isEdit = false }) => {
    const formik = useFormik({
        initialValues: {
            version_name: initialVersionName
        },
        validationSchema: Yup.object({
            version_name: Yup.string()
                .required("This is a mandatory field. Please complete it before continuing.")
                .test("len", "Must be less than 100 characters", (val) => val?.length <= 100)
        }),
        onSubmit: (values) => {
            handleSaveVersion(values.version_name);
            onClose();
        }
    });
    return (<Styled.NewVersionAlertContainer>
        <Styled.NewVersionAlertTitle>{isEdit ? "Edit Version" : "New Version"}</Styled.NewVersionAlertTitle>
        <TextInput
            fieldName="version_name"
            hasError={!!formik.errors.version_name}
            fieldLabel="Version Name*"
            placeholder="Enter version name"
            inputLimit={100}
            fieldValue={formik.values.version_name}
            onChangeHandler={formik.handleChange}
        />
        <Styled.ErrorText>{formik.errors.version_name}</Styled.ErrorText>
        <Styled.ButtonsContainer>
            <BaseButton size="sm" variant="secondary" onClick={onClose}>Cancel</BaseButton>
            <BaseButton size="sm" variant="primary" onClick={formik.submitForm}>{isEdit ? "Save" : "Create"}</BaseButton>
        </Styled.ButtonsContainer>
    </Styled.NewVersionAlertContainer>);
}
